const languages = [
  'English – Beginner',
  'English – Pre-Intermediate',
  'English – Intermediate',
  'English – Advanced',
  'English – Native',
  'French – Beginner',
  'French – Pre-Intermediate',
  'French – Intermediate',
  'French – Advanced',
  'French – Native',
  'Russian – Beginner',
  'Russian – Pre-Intermediate',
  'Russian – Intermediate',
  'Russian – Advanced',
  'Russian – Native',
  'Ukrainian – Beginner',
  'Ukrainian – Pre-Intermediate',
  'Ukrainian – Intermediate',
  'Ukrainian – Advanced',
  'Ukrainian – Native',
  'Polish – Beginner',
  'Polish – Pre-Intermediate',
  'Polish – Intermediate',
  'Polish – Advanced',
  'Polish – Native',
  'Spanish – Beginner',
  'Spanish – Pre-Intermediate',
  'Spanish – Intermediate',
  'Spanish – Advanced',
  'Spanish – Native',
  'Farsi – Beginner',
  'Farsi – Pre-Intermediate',
  'Farsi – Intermediate',
  'Farsi – Advanced',
  'Farsi – Native',
  'Portuguese – Beginner',
  'Portuguese – Pre-Intermediate',
  'Portuguese – Intermediate',
  'Portuguese – Advanced',
  'Portuguese – Native',
  'Italian – Beginner',
  'Italian – Pre-Intermediate',
  'Italian – Intermediate',
  'Italian – Advanced',
  'Italian – Native',
  'German – Beginner',
  'German – Pre-Intermediate',
  'German – Intermediate',
  'German – Advanced',
  'German – Native',
  'Bulgarian – Beginner',
  'Bulgarian – Pre-Intermediate',
  'Bulgarian – Intermediate',
  'Bulgarian – Advanced',
  'Bulgarian – Native',
  'Lithuanian – Beginner',
  'Lithuanian – Pre-Intermediate',
  'Lithuanian – Intermediate',
  'Lithuanian – Advanced',
  'Lithuanian – Native',
  'Czech – Beginner',
  'Czech – Pre-Intermediate',
  'Czech – Intermediate',
  'Czech – Advanced',
  'Czech – Native',
  'Arabic – Beginner',
  'Arabic – Pre-Intermediate',
  'Arabic – Intermediate',
  'Arabic – Advanced',
  'Arabic – Native',
  'Maracanese – Beginner',
  'Maracanese – Pre-Intermediate',
  'Maracanese – Intermediate',
  'Maracanese – Advanced',
  'Maracanese – Native',
  'Turkish – Beginner',
  'Turkish – Pre-Intermediate',
  'Turkish – Intermediate',
  'Turkish – Advanced',
  'Turkish – Native',
  'Georgian – Beginner',
  'Georgian – Pre-Intermediate',
  'Georgian – Intermediate',
  'Georgian – Advanced',
  'Georgian – Native',
  'Azerbaijani – Beginner',
  'Azerbaijani – Pre-Intermediate',
  'Azerbaijani – Intermediate',
  'Azerbaijani – Advanced',
  'Azerbaijani – Native',
  'Armenian – Beginner',
  'Armenian – Pre-Intermediate',
  'Armenian – Intermediate',
  'Armenian – Advanced',
  'Armenian – Native',
  'Romanian – Beginner',
  'Romanian – Pre-Intermediate',
  'Romanian – Intermediate',
  'Romanian – Advanced',
  'Romanian – Native',
  'Kinyarwanda – Beginner',
  'Kinyarwanda – Pre-Intermediate',
  'Kinyarwanda – Intermediate',
  'Kinyarwanda – Advanced',
  'Kinyarwanda – Native',
  'Swahili – Beginner',
  'Swahili – Pre-Intermediate',
  'Swahili – Intermediate',
  'Swahili – Advanced',
  'Swahili – Native',
  'Tigrinya – Beginner',
  'Tigrinya – Pre-Intermediate',
  'Tigrinya – Intermediate',
  'Tigrinya – Advanced',
  'Tigrinya – Native',
];

export default languages;
